// extracted by mini-css-extract-plugin
export default {"home":"CollegeAdmin_home__Pyp9G"};